var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"historylist"},[_c('img',{staticClass:"goback",attrs:{"src":require('../../../assets/images/powderedMilk/hisback.png'),"alt":""},on:{"click":function($event){return _vm.goBack()}}}),_c('history')],1)}
var staticRenderFns = []

export { render, staticRenderFns }